import { RegularMetricId } from '../../api/types-graphql';
import {
  DashboardConfig,
  KpiFactboxBenchmarkPeriods,
  KpiFactboxBenchmarkTypes,
  KpiV2Type,
} from '../../common/components/dashboards/types';
import { TimeSliderTypes } from '../../common/components/timeslider/types';
import { Languages } from '../../constants';
import { DataTypes, EmployeeDataFields, TimeSelectionType } from '../../types';

export const ShipHealthcareDashboardChartConfig: DashboardConfig = {
  id: 'shiphealthcare_custom_db_1',
  title: {
    [Languages.EN]: 'Monthly Group Report',
    [Languages.JA]: 'SHIP人材諸表®（月次報告）',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'General Info',
        [Languages.JA]: '基本情報',
      },
      pageOptions: {
        displayOptions: {
          enabled: false,
        },
        timeSlider: {
          enabled: true,
          type: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 5,
      components: ({
        storyboardDateUtils: {
          nowEndOfMonth,
          twelveMonthsAgoFromNowStartOfMonth,
        },
      }) => [
        {
          chartId: '1',
          title: {
            [Languages.EN]: 'Individuals',
            [Languages.JA]: '従業員',
          },
          footer: {
            [Languages.EN]: '1-footer', // TODO
            [Languages.JA]: '※対象期間末時点の総数',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'individuals',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0001_1IndividualsCount,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '2',
          title: {
            [Languages.EN]: 'Gender Ratio', // TODO
            [Languages.JA]: '男女比',
          },
          subtitle: {
            [Languages.EN]: 'Cumulative total at the end of the period', // TODO
            [Languages.JA]: '（女：男）', //  this is different from the eng subtitle
          },
          footer: {
            [Languages.EN]: '2-footer', // TODO
            [Languages.JA]: '※対象期間末時点における累計',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.DOUBLE_METRIC,
            sections: {
              leftSection: {
                key: 'female_percentage',
                title: {
                  [Languages.EN]: 'Female',
                  [Languages.JA]: '女性',
                },
                query: {
                  metrics: [
                    {
                      type: 'RegularMetricId',
                      value: RegularMetricId.Pm0020_2FhcPercHc,
                    },
                  ],
                  timeSelection: {
                    type: TimeSelectionType.CalendarYearSingleValueByMonths,
                    input: {
                      start: nowEndOfMonth,
                      end: nowEndOfMonth,
                    },
                  },
                },
                benchmarkConfigs: [
                  {
                    benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                    benchmarkType: KpiFactboxBenchmarkTypes.VALUE,
                  },
                ],
              },
              rightSection: {
                key: 'male_percentage',
                title: {
                  [Languages.EN]: 'Male',
                  [Languages.JA]: '男性',
                },
                query: {
                  metrics: [
                    {
                      type: 'RegularMetricId',
                      value: RegularMetricId.Pm0448_2MhcPerPerson,
                    },
                  ],
                  timeSelection: {
                    type: TimeSelectionType.CalendarYearSingleValueByMonths,
                    input: {
                      start: nowEndOfMonth,
                      end: nowEndOfMonth,
                    },
                  },
                },
                benchmarkConfigs: [
                  {
                    benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                    benchmarkType: KpiFactboxBenchmarkTypes.VALUE,
                  },
                ],
              },
            },
          },
        },
        {
          chartId: '3',
          title: {
            [Languages.EN]: '3-title', // TODO
            [Languages.JA]: '年齢',
          },
          subtitle: {
            [Languages.EN]: '3-subtitle', // TODO
            [Languages.JA]: '（平均）',
          },
          footer: {
            [Languages.EN]: '3-footer', // TODO
            [Languages.JA]: '※対象期間末時点の平均 ',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'age_avg',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0019_2AgeAvg,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '4',
          title: {
            [Languages.EN]: '4-title', // TODO
            [Languages.JA]: '勤続年数',
          },
          subtitle: {
            [Languages.EN]: '4-subtitle', // TODO
            [Languages.JA]: '（平均）',
          },
          footer: {
            [Languages.EN]: '4-footer', // TODO
            [Languages.JA]: '※対象期間末時点の平均 ',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'tenure_avg',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0023_2TenureAvg,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '5',
          title: {
            [Languages.EN]: '5-title', // TODO
            [Languages.JA]: '管理職比率',
          },
          footer: {
            [Languages.EN]: '5-footer', // TODO
            [Languages.JA]: '※対象期間末時点の比率',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'mngdef_perchc',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0014_2MngDefPercHc,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '6',
          title: {
            [Languages.EN]: '6-title', // TODO
            [Languages.JA]: '入社者',
          },
          footer: {
            [Languages.EN]: '6-footer', // TODO
            [Languages.JA]: '※対象期間における累計 ',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'joiners',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0006_1JoinersJoiners,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '7',
          title: {
            [Languages.EN]: '7-title', // TODO
            [Languages.JA]: '離職者',
          },
          footer: {
            [Languages.EN]: '7-footer', // TODO
            [Languages.JA]: '※対象期間における累計',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'leavers',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0007_1LeaversTermDateLeavers,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '8',
          title: {
            [Languages.EN]: '8-title', // TODO
            [Languages.JA]: '離職率',
          },
          footer: {
            [Languages.EN]: '8-footer', // TODO
            [Languages.JA]:
              '※直近12ヶ月で算出（計算式：選択した月から 直近12ヶ月間の月間離職率の合計）',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'attrition_ttm',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0076_3AttritionTtm,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '9',
          title: {
            [Languages.EN]: '9-title', // TODO
            [Languages.JA]: '入社１年以内離職率',
          },
          footer: {
            [Languages.EN]: '9-footer', // TODO
            [Languages.JA]:
              '※直近12ヶ月で算出（計算式：選択した月から 直近12ヶ月間の月間入社１年以内離職率の合計）',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: '1y_attrition',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value: RegularMetricId.Pm0290_1_1yAttritionAttrition,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: nowEndOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
        {
          chartId: '10',
          title: {
            [Languages.EN]: '10-title', // TODO
            [Languages.JA]: '育休取得率',
          },
          footer: {
            [Languages.EN]: '10-footer', // TODO
            [Languages.JA]:
              '※直近12ヶ月で算出（計算式：期間内に育休を 開始した人数÷同期間に子が誕生した人数）',
          },
          chartTypeConfig: { chartType: 'kpi-v2' },
          options: {
            kpiType: KpiV2Type.SINGLE_METRIC,
            section: {
              key: 'parental_leave_utilization_perc',
              query: {
                metrics: [
                  {
                    type: 'RegularMetricId',
                    value:
                      RegularMetricId.Pm0171ParentalLeaveTakenUtilizationPerc,
                  },
                ],
                timeSelection: {
                  type: TimeSelectionType.CalendarYearSingleValueByMonths,
                  input: {
                    start: twelveMonthsAgoFromNowStartOfMonth,
                    end: nowEndOfMonth,
                  },
                },
              },
              benchmarkConfigs: [
                {
                  benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
                  benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
                },
              ],
            },
          },
        },
      ],
    },
    {
      pageId: '2',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 2,
      enabled: true,
      title: {
        [Languages.EN]: 'Demographics',
        [Languages.JA]: '人員構成',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeSlider: {
          enabled: true,
          type: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 3,
      gridRows: 2,
      components: ({ storyboardDateUtils: { nowEndOfMonth } }) => [
        {
          chartId: '1',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '雇用形態別',
          },
          chartTypeConfig: { chartType: 'bar', timeframe: 'timePeriod' },
          gridColSpan: 1,
          queries: [
            {
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0001_1IndividualsCount,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearSingleValueByMonths,
                input: {
                  start: nowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
              segmentations: [
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.CUSTOM_FILTER_4,
                  },
                },
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.GENDER,
                  },
                },
              ],
            },
          ],
        },
        {
          chartId: '2',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '年齢構成',
          },
          chartTypeConfig: { chartType: 'bar', timeframe: 'timePeriod' },
          gridColSpan: 2,
          queries: [
            {
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0001_1IndividualsCount,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearSingleValueByMonths,
                input: {
                  start: nowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
              segmentations: [
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.AGE_GROUP,
                  },
                },
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.GENDER,
                  },
                },
              ],
            },
          ],
        },
        {
          chartId: '3',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '勤続年数グループ別',
          },
          chartTypeConfig: { chartType: 'bar', timeframe: 'timePeriod' },
          gridColSpan: 3,
          queries: [
            {
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0001_1IndividualsCount,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearSingleValueByMonths,
                input: {
                  start: nowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
              segmentations: [
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.TENURE_GROUP,
                  },
                },
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.GENDER,
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      pageId: '3',
      dashboardId: 'shiphealthcare_custom_db_1',
      pageNumber: 3,
      enabled: true,
      title: {
        [Languages.EN]: 'Joiners and Leavers',
        [Languages.JA]: '入社・離職',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeSlider: {
          enabled: true,
          type: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 8,
      gridRows: 2,
      components: ({
        storyboardDateUtils: {
          twelveMonthsAgoFromNowEndOfMonth,
          nowEndOfMonth,
          twelveMonthsAgoFromLastYearEndOfMonth,
          lastYearEndOfMonth,
        },
      }) => [
        {
          chartId: '1',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '入社者数・離職者数の推移（直近12ヶ月）',
          },
          chartTypeConfig: { chartType: 'line' },
          gridColSpan: 5,
          queries: [
            {
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0006_1JoinersJoiners,
                },
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0007_1LeaversTermDateLeavers,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearMonthly,
                input: {
                  start: twelveMonthsAgoFromNowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
            },
          ],
        },
        {
          chartId: '2',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '年代別、入社者数と離職者数の比較',
          },
          subtitle: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '（対象期間累計、上部参照）',
          },
          chartTypeConfig: { chartType: 'bar', timeframe: 'timePeriod' },
          gridColSpan: 3,
          queries: [
            {
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0006_1JoinersJoiners,
                },
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0007_1LeaversTermDateLeavers,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearSingleValueByMonths,
                input: {
                  start: twelveMonthsAgoFromNowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
              segmentations: [
                {
                  type: 'non-hierarchical',
                  dataField: {
                    dataType: DataTypes.EMPLOYEE,
                    dataField: EmployeeDataFields.AGE_GROUP,
                  },
                },
              ],
            },
          ],
        },
        {
          chartId: '3',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '入社者数の前年同月比（直近12ヶ月）',
          },
          chartTypeConfig: { chartType: 'line' },
          gridColSpan: 4,
          queries: [
            {
              xAxisId: 0,
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0006_1JoinersJoiners,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearMonthly,
                input: {
                  start: twelveMonthsAgoFromNowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
            },
            {
              isBenchmark: true,
              xAxisId: 1,
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0006_1JoinersJoiners,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearMonthly,
                input: {
                  start: twelveMonthsAgoFromLastYearEndOfMonth,
                  end: lastYearEndOfMonth,
                },
              },
            },
          ],
        },
        {
          chartId: '4',
          title: {
            [Languages.EN]: '', // TODO
            [Languages.JA]: '離職者数の前年同月比（直近12ヶ月）',
          },
          chartTypeConfig: { chartType: 'line' },
          gridColSpan: 4,
          queries: [
            {
              xAxisId: 0,
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0007_1LeaversTermDateLeavers,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearMonthly,
                input: {
                  start: twelveMonthsAgoFromNowEndOfMonth,
                  end: nowEndOfMonth,
                },
              },
            },
            {
              isBenchmark: true,
              xAxisId: 1,
              metrics: [
                {
                  type: 'RegularMetricId',
                  value: RegularMetricId.Pm0007_1LeaversTermDateLeavers,
                },
              ],
              timeSelection: {
                type: TimeSelectionType.CalendarYearMonthly,
                input: {
                  start: twelveMonthsAgoFromLastYearEndOfMonth,
                  end: lastYearEndOfMonth,
                },
              },
            },
          ],
        },
      ],
    },
  ],
};
